
import Vessels$002Emodule from "../../src/StenaWeather.WeatherServiceUI.Client/Pages/Vessels.module.scss";
import { ofArray, tryFindBack, length, truncate, where, singleton, empty, map } from "../fable_modules/fable-library-js.5.0.0/List.js";
import { concat, join } from "../fable_modules/fable-library-js.5.0.0/String.js";
import { Record, Union } from "../fable_modules/fable-library-js.5.0.0/Types.js";
import { Response_SessionType, Response_VesselInfo_$reflection } from "../StenaWeather.WeatherServiceUI.Shared/Vessels/API.js";
import { record_type, bool_type, union_type, list_type } from "../fable_modules/fable-library-js.5.0.0/Reflection.js";
import { ServerError_$reflection } from "../StenaWeather.WeatherServiceUI.Shared/Errors.js";
import { FSharpResult$2 } from "../fable_modules/fable-library-js.5.0.0/Result.js";
import { PageTitle_title, ErrorView_Cmd_ofError } from "../SharedView.js";
import { Cmd_none } from "../fable_modules/Fable.Elmish.5.0.2/cmd.fs.js";
import { onVesselsAPI, Cmd_OfAsync_eitherAsResult } from "../Server.js";
import { createElement, useState } from "react";
import React from "react";
import { comparePrimitives, equals } from "../fable_modules/fable-library-js.5.0.0/Util.js";
import { map as map_1, empty as empty_1, singleton as singleton_1, append, delay, toList } from "../fable_modules/fable-library-js.5.0.0/Seq.js";
import { formatToWholeUnits } from "../TimeSpan.js";
import { now, op_Subtraction } from "../fable_modules/fable-library-js.5.0.0/DateOffset.js";
import { ofList } from "../fable_modules/fable-library-js.5.0.0/Map.js";
import { Color, theme } from "../Theme.js";
import { TextModule_View } from "../Components/StenaWebUI/Core/Text.js";
import { TextVariant, TextSize } from "../Components/StenaWebUI/Core/Text.js";
import { IndentModule_View } from "../Components/StenaWebUI/Core/Indent.js";
import { SpacingModule_View } from "../Components/StenaWebUI/Core/Spacing.js";
import { ColumnModule_View } from "../Components/StenaWebUI/Core/Column.js";
import { ButtonBase_ViewPrimary, ButtonBase_ViewFlat } from "../Components/StenaWebUI/Elements/Button.js";
import { ButtonSize } from "../Components/StenaWebUI/Elements/Button.js";
import { RowModule_View } from "../Components/StenaWebUI/Core/Row.js";
import { BoxModule_View } from "../Components/StenaWebUI/Core/Box.js";
import { Page, Router_navigatePage } from "../Router.js";
import { LinkModule_View } from "../Components/StenaWebUI/Elements/Link.js";
import { IconModule_View } from "../Components/StenaWebUI/Icons/Icon.js";
import { faInfoCircle } from "@fortawesome/free-solid-svg-icons";
import { SpaceModule_View } from "../Components/StenaWebUI/Core/Space.js";
import { value as value_44 } from "../fable_modules/fable-library-js.5.0.0/Option.js";
import { defaultOf } from "../fable_modules/fable-library-js.5.0.0/Util.js";
import { UseElmishHelper_programWithCustomErrorHandler, React_useElmish_Z6C327F2E } from "../fable_modules/Feliz.UseElmish.5.0.0/UseElmish.fs.js";
import { ProgramModule_mkProgram } from "../fable_modules/Fable.Elmish.5.0.2/program.fs.js";
import { LoadingScreenModule_View } from "../Components/StenaWebUI/Panels/LoadingScreen.js";
import { HtmlHelper_createElement } from "../fable_modules/Feliz.3.3.3/Html.fs.js";
import { defaultOf as defaultOf_1 } from "../fable_modules/fable-library-js.5.0.0/Util.js";

export const cn = (() => {
    const styles = Vessels$002Emodule;
    const cnFn = (name) => (styles[name]);
    const cnFns = (names) => map((x) => (styles[x]), names);
    return {
        className: cnFn,
        classes: cnFns,
        prop: {
            className: (arg) => ["className", cnFn(arg)],
            classes: (arg_1) => ["className", join(" ", cnFns(arg_1))],
        },
    };
})();

export class Msg extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["LoadVessels", "OnVesselsLoaded"];
    }
}

export function Msg_$reflection() {
    return union_type("StenaWeather.WeatherServiceUI.Client.Pages.Vessels.Msg", [], Msg, () => [[], [["Item", union_type("Microsoft.FSharp.Core.FSharpResult`2", [list_type(Response_VesselInfo_$reflection()), ServerError_$reflection()], FSharpResult$2, () => [[["ResultValue", list_type(Response_VesselInfo_$reflection())]], [["ErrorValue", ServerError_$reflection()]]])]]]);
}

export class State extends Record {
    constructor(Vessels, IsLoading) {
        super();
        this.Vessels = Vessels;
        this.IsLoading = IsLoading;
    }
}

export function State_$reflection() {
    return record_type("StenaWeather.WeatherServiceUI.Client.Pages.Vessels.State", [], State, () => [["Vessels", list_type(Response_VesselInfo_$reflection())], ["IsLoading", bool_type]]);
}

export const init = [new State(empty(), false), singleton((dispatch) => {
    dispatch(new Msg(0, []));
})];

export function update(msg, state) {
    if (msg.tag === 1) {
        const vessels = msg.fields[0];
        if (vessels.tag === 1) {
            return [new State(state.Vessels, false), ErrorView_Cmd_ofError(vessels.fields[0])];
        }
        else {
            return [new State(vessels.fields[0], false), Cmd_none()];
        }
    }
    else {
        return [new State(state.Vessels, true), Cmd_OfAsync_eitherAsResult(() => onVesselsAPI((x) => x.GetVesselsInfo()), (Item) => (new Msg(1, [Item])))];
    }
}

const maxVisibleSessions = 10;

export function VesselBox($props) {
    let p_1_37;
    const vessel = $props.vessel;
    const patternInput = useState(false);
    const visibleSessions = where((f) => equals(f.SessionType, new Response_SessionType(0, [])), vessel.Sessions);
    const shownSessions = patternInput[0] ? visibleSessions : truncate(maxVisibleSessions, visibleSessions);
    const hiddenSessionsCount = (length(visibleSessions) - length(shownSessions)) | 0;
    const historicalSession = tryFindBack((f_1) => equals(f_1.SessionType, new Response_SessionType(1, [])), vessel.Sessions);
    const sessionText = (session_1) => concat(join("", map((m) => (m + " "), toList(delay(() => append((session_1.VoyageId.tag === 1) ? singleton_1("(merged)") : empty_1(), delay(() => ((session_1.Deleted != null) ? singleton_1("(closed)") : empty_1()))))))), "Initiated ", formatToWholeUnits(op_Subtraction(now(), session_1.CreatedAt)), ..." ago");
    const p_1_38 = ofList(map((value_43) => value_43, ofArray([["shadow", "box"], ["background", (length(visibleSessions) > 0) ? theme(new Color(1, [])) : theme(new Color(6, []))], ["children", singleton((p_1_37 = ofList(map((value_42) => value_42, ofArray([["width", "350px"], ["height", "100%"], ["children", toList(delay(() => {
        let p_1_13, p_1_12, p_1_6, p_1_5, p_1_3, p_1_11, p_1_9;
        return append(singleton_1((p_1_13 = ofList(map((value_13) => value_13, ofArray([["background", theme(new Color(6, []))], ["children", singleton((p_1_12 = ofList(map((value_12) => value_12, ofArray([["justifyContent", "space-between"], ["children", ofArray([(p_1_6 = ofList(map((value_6) => value_6, ofArray([["justifyContent", "center"], ["children", singleton((p_1_5 = ofList(map((value_5) => value_5, singleton(["children", singleton((p_1_3 = ofList(map((value_3) => value_3, singleton(["children", singleton(TextModule_View(ofList(map((value_1) => value_1, ofArray([["children", vessel.VesselName], ["size", new TextSize(0, [])], ["variant", new TextVariant(3, [])]])), {
            Compare: (x, y) => (comparePrimitives(x, y) | 0),
        })))])), {
            Compare: (x_1, y_1) => (comparePrimitives(x_1, y_1) | 0),
        }), createElement(IndentModule_View, {
            p: p_1_3,
        })))])), {
            Compare: (x_2, y_2) => (comparePrimitives(x_2, y_2) | 0),
        }), createElement(SpacingModule_View, {
            p: p_1_5,
        })))]])), {
            Compare: (x_3, y_3) => (comparePrimitives(x_3, y_3) | 0),
        }), createElement(ColumnModule_View, {
            p: p_1_6,
        })), (p_1_11 = ofList(map((value_11) => value_11, singleton(["children", singleton((p_1_9 = ofList(map((value_9) => value_9, singleton(["children", singleton(ButtonBase_ViewFlat(ofList(map((value_7) => value_7, ofArray([["label", "Data consumption"], ["size", new ButtonSize(2, [])]])), {
            Compare: (x_4, y_4) => (comparePrimitives(x_4, y_4) | 0),
        })))])), {
            Compare: (x_5, y_5) => (comparePrimitives(x_5, y_5) | 0),
        }), createElement(IndentModule_View, {
            p: p_1_9,
        })))])), {
            Compare: (x_6, y_6) => (comparePrimitives(x_6, y_6) | 0),
        }), createElement(SpacingModule_View, {
            p: p_1_11,
        }))])]])), {
            Compare: (x_7, y_7) => (comparePrimitives(x_7, y_7) | 0),
        }), createElement(RowModule_View, {
            p: p_1_12,
        })))]])), {
            Compare: (x_8, y_8) => (comparePrimitives(x_8, y_8) | 0),
        }), createElement(BoxModule_View, {
            p: p_1_13,
        }))), delay(() => {
            let p_1_24, p_1_23, p_1_36, p_1_35, p_1_28, t_29, p_1_29, p_1_34, p_1_31, p_1_33, p_1_32;
            return (length(visibleSessions) > 0) ? singleton_1((p_1_24 = ofList(map((value_27) => value_27, ofArray([["spacing", 1], ["indent", 1], ["children", singleton((p_1_23 = ofList(map((value_26) => value_26, ofArray([["gap", true], ["justifyContent", "space-between"], ["children", toList(delay(() => {
                let p_1_16;
                return append(singleton_1((p_1_16 = ofList(map((value_17) => value_17, singleton(["children", singleton(TextModule_View(ofList(map((value_15) => value_15, ofArray([["color", "#a8a8a8"], ["children", "Sessions"]])), {
                    Compare: (x_9, y_9) => (comparePrimitives(x_9, y_9) | 0),
                })))])), {
                    Compare: (x_10, y_10) => (comparePrimitives(x_10, y_10) | 0),
                }), createElement(SpacingModule_View, {
                    p: p_1_16,
                }))), delay(() => append(map_1((session_2) => {
                    let p_1_18, p_1_20, p_1_19;
                    const p_1_21 = ofList(map((value_23) => value_23, ofArray([["height", "100%"], ["justifyContent", "space-between"], ["children", ofArray([(p_1_18 = ofList(map((value_20) => value_20, ofArray([["alignItems", "center"], ["children", singleton(TextModule_View(ofList(map((value_19) => value_19, singleton(["children", sessionText(session_2)])), {
                        Compare: (x_11, y_11) => (comparePrimitives(x_11, y_11) | 0),
                    })))]])), {
                        Compare: (x_12, y_12) => (comparePrimitives(x_12, y_12) | 0),
                    }), createElement(ColumnModule_View, {
                        p: p_1_18,
                    })), (p_1_20 = ofList(map((value_22) => value_22, ofArray([["justifyContent", "flex-end"], ["children", singleton((p_1_19 = ofList(map((value_21) => value_21, ofArray([["id", "showOnMapButton"], ["label", "Show on map"], ["size", new ButtonSize(2, [])], ["onClick", (_arg) => {
                        Router_navigatePage(new Page(2, [session_2.VoyageId]));
                    }]])), {
                        Compare: (x_13, y_13) => (comparePrimitives(x_13, y_13) | 0),
                    }), createElement(ButtonBase_ViewPrimary, {
                        p: p_1_19,
                    })))]])), {
                        Compare: (x_14, y_14) => (comparePrimitives(x_14, y_14) | 0),
                    }), createElement(ColumnModule_View, {
                        p: p_1_20,
                    }))])]])), {
                        Compare: (x_15, y_15) => (comparePrimitives(x_15, y_15) | 0),
                    });
                    return createElement(RowModule_View, {
                        p: p_1_21,
                    });
                }, shownSessions), delay(() => {
                    let p_1_22;
                    return (hiddenSessionsCount > 0) ? singleton_1((p_1_22 = ofList(map((value_25) => value_25, ofArray([["onClick", () => {
                        patternInput[1](true);
                    }], ["children", `Show all (${length(visibleSessions)})`]])), {
                        Compare: (x_16, y_16) => (comparePrimitives(x_16, y_16) | 0),
                    }), createElement(LinkModule_View, {
                        p: p_1_22,
                    }))) : empty_1();
                }))));
            }))]])), {
                Compare: (x_17, y_17) => (comparePrimitives(x_17, y_17) | 0),
            }), createElement(ColumnModule_View, {
                p: p_1_23,
            })))]])), {
                Compare: (x_18, y_18) => (comparePrimitives(x_18, y_18) | 0),
            }), createElement(BoxModule_View, {
                p: p_1_24,
            }))) : singleton_1((p_1_36 = ofList(map((value_41) => value_41, ofArray([["indent", 1], ["spacing", 1], ["height", "100%"], ["children", singleton((p_1_35 = ofList(map((value_40) => value_40, ofArray([["height", "100%"], ["children", ofArray([(p_1_28 = ofList(map((value_32) => value_32, singleton(["children", ofArray([IconModule_View(ofList(map((value_28) => value_28, ofArray([(t_29 = faInfoCircle, ["icon", t_29]), ["size", 15]])), {
                Compare: (x_19, y_19) => (comparePrimitives(x_19, y_19) | 0),
            })), TextModule_View(ofList(map((value_30) => value_30, ofArray([["children", concat(vessel.VesselName, ..." doesn\'t have any open sessions at this moment")], ["variant", new TextVariant(0, [])]])), {
                Compare: (x_20, y_20) => (comparePrimitives(x_20, y_20) | 0),
            }))])])), {
                Compare: (x_21, y_21) => (comparePrimitives(x_21, y_21) | 0),
            }), createElement(IndentModule_View, {
                p: p_1_28,
            })), (p_1_29 = ofList(map((value_33) => value_33, empty()), {
                Compare: (x_22, y_22) => (comparePrimitives(x_22, y_22) | 0),
            }), createElement(SpaceModule_View, {
                p: p_1_29,
            })), (p_1_34 = ofList(map((value_39) => value_39, ofArray([["justifyContent", "space-between"], ["height", "100%"], ["children", ofArray([(p_1_31 = ofList(map((value_36) => value_36, singleton(["children", toList(delay(() => ((historicalSession != null) ? singleton_1(TextModule_View(ofList(map((value_35) => value_35, singleton(["children", sessionText(value_44(historicalSession))])), {
                Compare: (x_23, y_23) => (comparePrimitives(x_23, y_23) | 0),
            }))) : singleton_1(defaultOf()))))])), {
                Compare: (x_24, y_24) => (comparePrimitives(x_24, y_24) | 0),
            }), createElement(ColumnModule_View, {
                p: p_1_31,
            })), (p_1_33 = ofList(map((value_38) => value_38, ofArray([["justifyContent", "flex-end"], ["children", singleton((p_1_32 = ofList(map((value_37) => value_37, toList(delay(() => append(singleton_1(["id", "showOnMapButton"]), delay(() => append(singleton_1(["label", "Show historical data"]), delay(() => append(singleton_1(["size", new ButtonSize(2, [])]), delay(() => append((historicalSession == null) ? append(singleton_1(["disabled", true]), delay(() => singleton_1(["label", "No historical data"]))) : empty_1(), delay(() => singleton_1(["onClick", (_arg_2) => {
                if (historicalSession != null) {
                    Router_navigatePage(new Page(2, [value_44(historicalSession).VoyageId]));
                }
            }])))))))))))), {
                Compare: (x_25, y_25) => (comparePrimitives(x_25, y_25) | 0),
            }), createElement(ButtonBase_ViewPrimary, {
                p: p_1_32,
            })))]])), {
                Compare: (x_26, y_26) => (comparePrimitives(x_26, y_26) | 0),
            }), createElement(ColumnModule_View, {
                p: p_1_33,
            }))])]])), {
                Compare: (x_27, y_27) => (comparePrimitives(x_27, y_27) | 0),
            }), createElement(RowModule_View, {
                p: p_1_34,
            }))])]])), {
                Compare: (x_28, y_28) => (comparePrimitives(x_28, y_28) | 0),
            }), createElement(ColumnModule_View, {
                p: p_1_35,
            })))]])), {
                Compare: (x_29, y_29) => (comparePrimitives(x_29, y_29) | 0),
            }), createElement(BoxModule_View, {
                p: p_1_36,
            })));
        }));
    }))]])), {
        Compare: (x_30, y_30) => (comparePrimitives(x_30, y_30) | 0),
    }), createElement(ColumnModule_View, {
        p: p_1_37,
    })))]])), {
        Compare: (x_31, y_31) => (comparePrimitives(x_31, y_31) | 0),
    });
    return createElement(BoxModule_View, {
        p: p_1_38,
    });
}

export function VesselsView() {
    const state_1 = React_useElmish_Z6C327F2E(() => UseElmishHelper_programWithCustomErrorHandler(undefined, ProgramModule_mkProgram(() => init, update, (_arg, _arg_1) => {
    })), undefined, [])[0];
    const children = toList(delay(() => append(singleton_1(PageTitle_title("List of Vessels", "Choose vessel to display all details or click on current session if exists")), delay(() => {
        let p_1_1;
        return state_1.IsLoading ? singleton_1((p_1_1 = ofList(map((value) => value, singleton(["text", "Loading vessels..."])), {
            Compare: (x, y) => (comparePrimitives(x, y) | 0),
        }), createElement(LoadingScreenModule_View, {
            p: p_1_1,
        }))) : singleton_1(HtmlHelper_createElement("div", ofArray([["className", cn.className("cards")], ["children", toList(delay(() => map((vessel) => createElement(VesselBox, {
            vessel: vessel,
        }), state_1.Vessels)))]])));
    }))));
    return createElement("div", defaultOf_1(), ...children);
}

